import {sortHML} from './util';
import ReferencesField from "../Forms/CustomFields/ReferencesField.svelte";
import ReferenceLibraryField from '../Forms/CustomFields/ReferenceLibraryField.svelte';
import CustomTags from '../Forms/CustomFields/CustomTags.svelte';

export default function parseFields(fields, include_name=true) {
    let formFields = [];
    let sortFields = [];

    if (include_name) {
        formFields.push({name: "name", label: "Name", type: "textarea", required: true});
        sortFields.push({field: "name", label: "Name", dataAttr: "name"});
    }

    for (let field of fields) {
        if (field.details) {
            field = field.details;
        }

        let formField = {
            name: field.name,
            label: field.name,
            type: field.type,
            required: field.required,
            options: field.options
        };

        let sortField = {
            field: field.name,
            label: field.label || field.name,
            dataAttr: field.name,
            type: field.type,
            default_hidden: field.default_hidden
        }

        if (field.type == "select") {
            formField.choices = {
                static: field.options
            };
        } else if (field.type == "risk") {
            formField.dflt = "High";

            sortField.vCenter = true;
            sortField.hCenter = true;

            sortField.sort_func = sortHML(field.name);
        } else if (field.type == "references") {
            sortField.component = ReferencesField;
            sortField.componentProps = {
                disabled: true
            }
        } else if (field.type == "referenceLibrary") {
            formField.type = "custom";
            formField.component = ReferenceLibraryField;
            sortField.component = ReferenceLibraryField;
            sortField.componentProps = {
                readOnly: true
            }

            sortField.filterFunc = (filter, item) => {
                if (!item[field.name]) return false

                for (let reference of item[field.name]) {
                    if (reference.control && reference.control.toLowerCase().includes(filter.toLowerCase())) {
                        return true
                    }

                    if (reference.framework && reference.framework.toLowerCase().includes(filter.toLowerCase())) {
                        return true
                    }
                }
            }
        } else if (field.type == "customTags") {
            sortField.component = CustomTags;
            sortField.componentProps = {
                readonly: true
            }

        }

        formFields.push(formField);
        sortFields.push(sortField);
    }

    return {
        formFields,
        sortFields
    }
}